import ButtonIconH from "./ButtonIconH";

export function OrderActionButtons({
  validateOrder,
  focusFields,
  saveOrder,
  deleteOrder,
  onSave,
  onClose,
  idPedido,
  createPopupQuestion,
  removePopupQuestion,
}) {
  return (
    <div className="popup-buttons" style={{ margin: "10px 25% 0 25%" }}>
      <ButtonIconH
        text="Guardar"
        onClick={async () => {
          if (!validateOrder()) {
            createPopupQuestion(
              "Por favor, rellene todos los campos obligatorios del pedido.",
              async () => {
                removePopupQuestion();
                focusFields();
              },
              null,
              "Entendido",
            );
          } else {
            await saveOrder();
          }
        }}
      ></ButtonIconH>
      {idPedido !== -1 && (
        <ButtonIconH
          text="Eliminar"
          onClick={async () => {
            createPopupQuestion(
              "¿Desea eliminar el pedido?",
              async () => {
                removePopupQuestion();
                await deleteOrder();
                onSave();
                onClose();
              },
              () => {
                removePopupQuestion();
              },
              "Sí",
              "No",
            );
          }}
        ></ButtonIconH>
      )}
    </div>
  );
}
